import React from 'react';
import { FC } from 'react';

export const CheckSolid: FC<{}> = () => (
    <svg width='28' height='21' viewBox='0 0 28 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M26.2812 0.28125L9 17.5625L1.71875 10.2812L0.28125 11.7188L8.28125 19.7188L9 20.4062L9.71875 19.7188L27.7188 1.71875L26.2812 0.28125Z'
            fill='white'
        />
    </svg>
);
